module.exports = __webpack_public_path__ + "static/media/cover-serverless-mini.a34a20b6.png";